import { PlusOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Empty,
  Image,
  Modal,
  notification,
  Row,
  Skeleton,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import default_bank from '../../../Assets/ic_default_bank.png';
import LinkedDelinkedAccountResponse, {
  LinkedDelinkedAccountObject,
} from '../../../Models/Response/Account/LinkedDelinkedAccounts';
import {
  delinkAccounts,
  delinkAccountVerification,
  getConsentLinkedWithAccount,
  getLinkedAccountsOfUser,
} from '../../../Services/AccountsServices/AccountService';
import { authType } from '../../../Utils/Constants/authType';
import { Routes } from '../../../Utils/Constants/routes';
import OTPInputComponent from '../../Common/Components/OTPModal';

import { logoBaseUrl } from '../../../Utils/Constants/baseUrl';
import './index.scss';
import { useSelector } from 'react-redux';

const Accounts: React.FC = () => {
  const [linkedAccounts, setLinkedAccounts] = useState(
    new Array<LinkedDelinkedAccountObject>()
  );
  const history = useHistory();
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );
  const [isOTPModalVisible, setIsOTPModalVisible] = useState(false);
  const [otpUniqueID, setOTPUniqueId] = useState('');
  const [linkedConsentsCount, setLinkedConsentsCount] = useState(0);
  const [isDelinkedConfirmationVisible, setIsDelinkedConfirmationVisible] =
    useState(false);
  const [selectedAccount, setSelectedAccount] = useState({
    fipHandle: '',
    accountRefNumber: '',
    accountType: '',
    linkRefNumber: '',
    maskedAccNumber: '',
    fipName: '',
    txnId: '',
  });
  const { t } = useTranslation();

  useEffect(() => {
    getLinkedAccounts();
  }, []);

  const getLinkedAccounts = () => {
    getLinkedAccountsOfUser()
      .then((res) => res.data)
      .then((res: LinkedDelinkedAccountResponse) => {
        setLinkedAccounts(res);
      });
  };

  const closeModal = () => {
    setIsOTPModalVisible(false);
  };

  const onDelinkAccount = (otp: string) => {
    delinkAccountVerification({
      FipId: selectedAccount.fipHandle,
      txnId: selectedAccount.txnId,
      linkRefNumber: selectedAccount.linkRefNumber,
      authType: authType.OTP,
      authValue: otp,
      otpUniqueID,
    }).then(() => {
      notification.success({
        message: t('Account DeLinked Successfully'),
      });
      history.push(Routes.account);
      getLinkedAccounts();
      setIsOTPModalVisible(false);
    });
  };

  const delinkAccountConfirmation = (account: LinkedDelinkedAccountObject) => {
    getConsentLinkedWithAccount(account.fipHandle, account.linkRefNumber)
      .then((res) => res.data)
      .then((res) => {
        setLinkedConsentsCount(res);
        setIsDelinkedConfirmationVisible(true);
      });
  };

  const delinkAccount = (account: LinkedDelinkedAccountObject) => {
    setIsDelinkedConfirmationVisible(false);
    delinkAccounts({
      FipId: account.fipHandle,
      txnId: account.txnId,
      linkRefNumber: account.linkRefNumber,
    })
      .then((res) => res.data)
      .then((res) => {
        setIsOTPModalVisible(true);
        setOTPUniqueId(res.otpUniqueID);
      });
  };
  const closeConfirmation = () => {
    setIsDelinkedConfirmationVisible(false);
  };
  const linkAccounts = () => history.push(Routes.linkAccounts);

  const deLinkAccountResendOTP = () => delinkAccount(selectedAccount);

  return (
    <>
      <Modal
        title='Delink Account'
        open={isDelinkedConfirmationVisible}
        footer={null}
        onCancel={closeConfirmation}
      >
        <div className='confirmDelinkModal'>
          <Typography.Text className='consentCountText'>
            {linkedConsentsCount && linkedConsentsCount !== 0
              ? `There ${
                  linkedConsentsCount === 1 ? 'is ' : 'are '
                } ${linkedConsentsCount} ${
                  linkedConsentsCount === 1 ? 'consent' : 'consents'
                } associated with this account. Please revoke all the active/pause consents to de-link account.`
              : ''}
          </Typography.Text>
          {linkedConsentsCount === 0 ? (
            <Typography.Text className='marginTop5'>
              {t('Are you sure you want to go ahead and delink?')}
            </Typography.Text>
          ) : (
            <></>
          )}
          <div>
            <Button
              disabled={linkedConsentsCount !== 0}
              className='primaryButton delinkAccountButton'
              onClick={() => delinkAccount(selectedAccount)}
            >
              {' '}
              {t('Delink Account')}
            </Button>
          </div>
        </div>
      </Modal>
      <OTPInputComponent
        onCancel={closeModal}
        isOpen={isOTPModalVisible}
        onOtpSubmit={onDelinkAccount}
        okText={t('CONFIRM')}
        title={t('Delink Account')}
        onResend={deLinkAccountResendOTP}
      />
      <div className='accountsRoot'>
        <Typography.Title
          level={2}
          style={{
            marginLeft: 'auto',
            color: 'var(--ant-primary-color)',
            width: '95%',
            marginRight: 'auto',
            marginTop: 15,
          }}
        >
          {t('Linked Account(s)')}
        </Typography.Title>
        {/* <Tabs defaultActiveKey="1" centered={true} id="accountsTab">
          <TabPane tab="Linked Account(s)" key="1"> */}
        <div style={{ overflowY: 'auto' }}>
          <Row justify={'space-between'}>
            {loading ? (
              <>
                <Col
                  style={{ marginTop: 10 }}
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 11 }}
                  md={{ span: 7 }}
                  lg={{ span: 7 }}
                >
                  {' '}
                  <Skeleton />{' '}
                </Col>
                <Col
                  span={6}
                  style={{ marginTop: 10 }}
                  xs={{ span: 24 }}
                  sm={{ span: 11 }}
                  md={{ span: 7 }}
                  lg={{ span: 7 }}
                >
                  {' '}
                  <Skeleton />{' '}
                </Col>
                <Col
                  style={{ marginTop: 10 }}
                  span={6}
                  xs={{ span: 24 }}
                  sm={{ span: 11 }}
                  md={{ span: 7 }}
                  lg={{ span: 7 }}
                >
                  {' '}
                  <Skeleton />{' '}
                </Col>
                <Col
                  span={6}
                  style={{ marginTop: 10 }}
                  xs={{ span: 24 }}
                  sm={{ span: 11 }}
                  md={{ span: 7 }}
                  lg={{ span: 7 }}
                >
                  {' '}
                  <Skeleton />{' '}
                </Col>
                <Col
                  span={6}
                  style={{ marginTop: 10 }}
                  xs={{ span: 24 }}
                  sm={{ span: 11 }}
                  md={{ span: 7 }}
                  lg={{ span: 7 }}
                >
                  {' '}
                  <Skeleton />{' '}
                </Col>
                <Col
                  span={6}
                  style={{ marginTop: 10 }}
                  xs={{ span: 24 }}
                  sm={{ span: 11 }}
                  md={{ span: 7 }}
                  lg={{ span: 7 }}
                >
                  {' '}
                  <Skeleton />{' '}
                </Col>
              </>
            ) : linkedAccounts.length ? (
              linkedAccounts.map(
                (account: LinkedDelinkedAccountObject, index: number) => (
                  <Col
                    span={6}
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 8 }}
                    lg={{ span: 8 }}
                  >
                    <Card className='accountCard linkedAccountCard' key={index}>
                      {account && (
                        <Image
                          className='fipLogo'
                          src={logoBaseUrl + account.fipHandle + '.png'}
                          fallback={default_bank}
                          preview={false}
                        />
                      )}
                      <div className='accounts'>
                        <Typography.Text id='accountsAccType'>
                          {account && account.fipName}
                        </Typography.Text>
                        <Typography.Text id='accountsAccType'>
                          {account && account.accountType}
                        </Typography.Text>
                        <Typography.Text id='accountsMaskedNumber'>
                          {account.maskedAccNumber}
                        </Typography.Text>
                        <Typography.Text
                          className='delinkButton'
                          type='danger'
                          // tslint:disable-next-line: jsx-no-lambda
                          onClick={() => {
                            setSelectedAccount(account);
                            delinkAccountConfirmation(account);
                          }}
                        >
                          {t('Delink Account')}
                        </Typography.Text>
                      </div>
                    </Card>
                  </Col>
                )
              )
            ) : (
              <Empty
                style={{ margin: '10px auto' }}
                description={
                  <Typography.Text className='noAccountFound'>
                    {t('No')} {t('Linked Accounts')}
                  </Typography.Text>
                }
              />
            )}
          </Row>
        </div>
        {/* </TabPane>
        </Tabs> */}
        <Button
          id='addAccount'
          className='primaryButton'
          onClick={linkAccounts}
        >
          <PlusOutlined /> {t('Add Accounts')}
        </Button>
      </div>
    </>
  );
};

export default Accounts;
